import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: '',
    IdUnidade: ''
  },
  mutations: {
    setAccessToken (state, token) {
      state.accessToken = token
    },
    setIdUnidade (state, IdUnidade) {
      state.IdUnidade = IdUnidade
    }
  },
  actions: {
  },
  modules: {
  }
})
